import React from 'react';
import { useReveal } from '../lib/useReveal';
const TESTIMONIALS = [{
  initials: 'MG',
  name: 'Marcela G.',
  location: 'Córdoba',
  text: '"Llevaba años queriendo formarme en Reiki de verdad. En una semana tenía mi primer cliente. El protocolo de sintonizaciones es oro puro."'
}, {
  initials: 'LP',
  name: 'Laura P.',
  location: 'Rosario',
  text: '"El material más completo que vi en español. El certificado está enmarcado en mi consultorio y mis clientes lo ven apenas entran."'
}, {
  initials: 'RM',
  name: 'Romina M.',
  location: 'Buenos Aires',
  text: '"Ya hacía terapia floral. El MegaPack completó todo lo que me faltaba. Ahora tengo lista de espera."'
}];
export function TestimonialsSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-black py-12 md:py-16 px-5 sm:px-6 border-t border-white/5" data-id="element-511">
      <div className="container mx-auto max-w-5xl" data-id="element-512">
        <div ref={ref1} className={`reveal grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 ${vis1 ? 'is-visible' : ''}`} data-id="element-513">
          {TESTIMONIALS.map((t, idx) => <div key={idx} className="bg-[#111111] border border-white/5 rounded-2xl p-6 flex flex-col" data-id="element-514">
              <div className="flex items-center gap-3 mb-4" data-id="element-515">
                <div className="w-10 h-10 rounded-full bg-[#eab308]/20 border border-[#eab308]/30 flex items-center justify-center text-[#eab308] font-bold text-sm" data-id="element-516">
                  {t.initials}
                </div>
                <div data-id="element-517">
                  <div className="flex text-[#eab308] text-sm mb-0.5" data-id="element-518">
                    ⭐⭐⭐⭐⭐
                  </div>
                  <p className="text-white font-bold text-sm" data-id="element-519">
                    {t.name}{' '}
                    <span className="text-gray-500 font-normal" data-id="element-520">
                      — {t.location}
                    </span>
                  </p>
                </div>
              </div>
              <p className="text-gray-300 text-sm leading-relaxed italic" data-id="element-521">
                {t.text}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}